// import du style
import './connection-request-ac.pdf.scss';
// Import des logos et images pour le pdf
import logo from '../../assets/images/logoSDDEA_new.png';
import logoOne from '../../assets/images/pdf/logo-one.png';
import logoTwo from '../../assets/images/pdf/logo-two.png';
import logoThree from '../../assets/images/pdf/logo-three.png';
import logoFour from '../../assets/images/pdf/logo-four.png';
import logoFive from '../../assets/images/pdf/logo-five.png';
import ForwardIcon from '@mui/icons-material/Forward';
import blocSign from '../../assets/images/pdf/bloc-sign.png';
import infosSddea from '../../assets/images/pdf/infos-sddea.png';
import { Field } from 'formik';

/**
 * ConnectionRequestAcPdf - Renders a connection request form for a PDF document.
 *
 * @returns {JSX.Element} The rendered connection request form.
 */
export function ConnectionRequestAcPdf(): JSX.Element {
    // Construction de tout le PDF (c'est long)
    // Il est divisé en différents tableaux
    // Les champs sont remplissables avec checkbox et bouton radio
    // Au submit, il sera retransformé en pdf pour affichage et envoi.
    return (
        <div id="wrapper" className={'raccordement-ac-pdf'}>
            <div id={'header'} className={'header-pdf'}>
                {/*Logo SDDEA*/}
                <img
                    src={logo}
                    style={{ height: '100px', paddingLeft: '40px', paddingTop: '30px' }}
                    alt={'logo SDDEA'}
                />
                {/*En-tête*/}
                {/*tableau*/}
                <table border={0}>
                    {/*body du tableau*/}
                    <tbody>
                        <tr>
                            <td>
                                {/*sous-titre*/}
                                <p
                                    className={'s1'}
                                    style={{
                                        paddingTop: '20pt',
                                        textAlign: 'center',
                                    }}
                                >
                                    SERVICE PUBLIC D’ASSAINISSEMENT COLLECTIF
                                </p>
                                {/*titre*/}
                                <h2
                                    className={'title'}
                                    style={{
                                        paddingTop: '10px',
                                        textAlign: 'center',
                                        display: 'flex',
                                        justifyContent: 'center',
                                        alignItems: 'end',
                                        position: 'relative',
                                        margin: '0 15%',
                                    }}
                                >
                                    Demande de contrôle de raccordement des installations privatives au réseau
                                    d’assainissement collectif
                                </h2>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            {/*Phrase d'accroche*/}
            <p className={'s2'} style={{ paddingTop: '30pt', textAlign: 'center' }}>
                Pour la prise en charge de votre dossier, veuillez nous fournir tous les renseignements ci-après
                (Remplir un formulaire par logement)
            </p>
            {/*tableau*/}
            <table>
                {/*tableau header*/}
                <tbody>
                    <tr>
                        <td width={'5%'} className={'tdImage'}></td>
                        <td style={{ width: '90%' }}>
                            {/*Objet*/}
                            {/* Séléction unique */}
                            <div className={'s11'} style={{ paddingTop: '9pt', textAlign: 'center' }}>
                                <label>Objet :</label>
                                {/*valeur Construction neuve*/}
                                <label>
                                    <Field type={'radio'} name={'objet'} value={'Construction neuve'} />
                                    <span>Construction neuve</span>
                                </label>
                                {/*valeur Modification d’installations*/}
                                <label>
                                    <Field type={'radio'} name={'objet'} value={'Modification d’installations'} />
                                    <span>Modification d’installations</span>
                                </label>
                                {/*valeur Contre-visite construction neuve*/}
                                <label>
                                    <Field type={'radio'} name={'objet'} value={'Contre-visite construction neuve'} />
                                    <span>Contre-visite construction neuve</span>
                                </label>
                                {/*valeur Autre*/}
                                <label>
                                    <Field type={'radio'} name={'objet'} value={'Autre'} />
                                    <span>Autre (Préciser) : </span>
                                </label>
                                <Field type={'text'} style={{ width: '160px' }} name={'objetAutre'} />
                            </div>
                        </td>
                        <td width={'5%'}></td>
                    </tr>
                    {/*Coordonnées du demandeur*/}
                    <tr>
                        <td width={'5%'} className={'tdImage'} style={{ textAlign: 'right' }}>
                            {/*logo*/}
                            <p
                                style={{
                                    marginTop: '20px',
                                    marginBottom: '10px',
                                    padding: '5px',
                                }}
                            >
                                <img src={logoOne} style={{ height: '30px' }} alt={'Numéro 1'} />
                            </p>
                        </td>
                        <td style={{ width: '90%' }}>
                            {/*titre*/}
                            <p
                                style={{
                                    backgroundColor: '#4EC6E0',
                                    marginTop: '20px',
                                    marginBottom: '10px',
                                    padding: '5px',
                                }}
                            >
                                <span className={'h3'}>Coordonnées du demandeur</span>
                            </p>
                        </td>
                        <td width={'5%'}></td>
                    </tr>
                    <tr>
                        <td width={'5%'} className={'tdImage'}></td>
                        <td width={'90%'}>
                            <p className={'s11'}>
                                {/*Données des infos du particulier*/}
                                <label>
                                    <Field type={'radio'} name={'estUnParticulierDemandeur'} value={'oui'} />
                                    <span style={{ color: '#0088cb' }}>Particulier</span>
                                </label>
                                <span style={{ color: '#231F20' }}>
                                    {/*valeur Madame*/}
                                    <label>
                                        <Field type={'radio'} name={'civiliteDemandeur'} value={'Madame'} />
                                        <span>Madame</span>
                                    </label>
                                    {/*valeur Monsieur*/}
                                    <label>
                                        <Field type={'radio'} name={'civiliteDemandeur'} value={'Monsieur'} />
                                        <span>Monsieur</span>
                                    </label>
                                    {/*valeur nom*/}
                                    Nom : <Field type={'text'} name={'nomDemandeur'} />
                                    {/*valeur prenom*/}
                                    Prénom : <Field type={'text'} name={'prenomDemandeur'} />
                                </span>
                            </p>
                            <p className={'s11'}>
                                {/*donnée entreprise*/}
                                <label>
                                    <Field type={'radio'} name={'estUnParticulierDemandeur'} value={'non'} />
                                    <span style={{ color: '#0088cb' }}>Entreprise, association, collectivité</span>
                                </label>
                                {/*nom et dossier*/}
                                <span style={{ color: '#231F20' }}>
                                    Nom : <Field type={'text'} name={'nomEntrepriseDemandeur'} />
                                    Dossier suivi par : <Field type={'text'} name={'dossierSuiviParDemandeur'} />
                                </span>
                            </p>
                            {/*SIRET*/}
                            <p className={'s11'}>
                                N° SIRET : <Field type={'text'} name={'siretDemandeur'} />
                            </p>
                            {/*adresse*/}
                            <p className={'s11'}>
                                Adresse (N°/additif/voie) :<Field type={'text'} name={'adresseDemandeur'} />
                            </p>
                            {/*code postal et commune*/}
                            <p className={'s11'}>
                                Code postal : <Field type={'text'} name={'codePostalDemandeur'} />
                                Commune : <Field type={'text'} name={'communeDemandeur'} />
                            </p>
                            {/*telephone et email*/}
                            <p className={'s11'}>
                                Téléphone (Portable et/ou fixe) : <Field type={'text'} name={'telephoneDemandeur'} />
                                Email : <Field type={'text'} name={'emailDemandeur'} />
                            </p>
                        </td>
                        <td width={'5%'}></td>
                    </tr>
                    {/*Coordonnées du propriétaire*/}
                    <tr>
                        <td width={'5%'} className={'tdImage'}></td>
                        <td style={{ width: '90%' }}>
                            {/*titre*/}
                            <p
                                style={{
                                    backgroundColor: '#4EC6E0',
                                    marginTop: '20px',
                                    marginBottom: '10px',
                                    padding: '5px',
                                }}
                            >
                                <span className={'h3'}>Coordonnées du propriétaire</span>
                                <span className={'s6'}>(si différent du demandeur)</span>
                            </p>

                            <p className={'s11'}>
                                {/*Données des infos du particulier*/}
                                <label>
                                    <Field type={'radio'} name={'estUnParticulierProprietaire'} value={'oui'} />
                                    <span style={{ color: '#0088cb' }}>Particulier</span>
                                </label>
                                <span style={{ color: '#231F20' }}>
                                    {/*valeur Madame*/}
                                    <label>
                                        <Field type={'radio'} name={'civiliteProprietaire'} value={'Madame'} />
                                        <span>Madame</span>
                                    </label>
                                    {/*valeur Monsieur*/}
                                    <label>
                                        <Field type={'radio'} name={'civiliteProprietaire'} value={'Monsieur'} />
                                        <span>Monsieur</span>
                                    </label>
                                    {/*valeur nom*/}
                                    Nom : <Field type={'text'} name={'nomProprietaire'} />
                                    {/*valeur prenom*/}
                                    Prénom : <Field type={'text'} name={'prenomProprietaire'} />
                                </span>
                            </p>
                            <p className={'s11'}>
                                {/*donnée entreprise*/}
                                <label>
                                    <Field type={'radio'} name={'estUnParticulierProprietaire'} value={'non'} />
                                    <span style={{ color: '#0088cb' }}>Entreprise, association, collectivité</span>
                                </label>
                                {/*nom et dossier*/}
                                <span style={{ color: '#231F20' }}>
                                    Nom : <Field type={'text'} name={'nomEntrepriseProprietaire'} />
                                    Dossier suivi par : <Field type={'text'} name={'dossierSuiviParProprietaire'} />
                                </span>
                            </p>
                            {/*SIRET*/}
                            <p className={'s11'}>
                                N° SIRET : <Field type={'text'} name={'siretProprietaire'} />
                            </p>
                            {/*adresse*/}
                            <p className={'s11'}>
                                Adresse (N°/additif/voie) :<Field type={'text'} name={'adresseProprietaire'} />
                            </p>
                            {/*code postal et commune*/}
                            <p className={'s11'}>
                                Code postal : <Field type={'text'} name={'codePostalProprietaire'} />
                                Commune : <Field type={'text'} name={'communeProprietaire'} />
                            </p>
                            {/*telephone et email*/}
                            <p className={'s11'}>
                                Téléphone (Portable et/ou fixe) : <Field type={'text'} name={'telephoneProprietaire'} />
                                Email : <Field type={'text'} name={'emailProprietaire'} />
                            </p>
                        </td>
                        <td width={'5%'}></td>
                    </tr>
                    {/*Coordonnées du payeur*/}
                    <tr>
                        <td width={'5%'} className={'tdImage'}></td>
                        <td style={{ width: '90%' }}>
                            {/*titre*/}
                            <p
                                style={{
                                    backgroundColor: '#4EC6E0',
                                    marginTop: '20px',
                                    marginBottom: '10px',
                                    padding: '5px',
                                }}
                            >
                                <span className={'h3'}>Coordonnées du payeur</span>
                                <span className={'s6'}>(si différent du demandeur)</span>
                            </p>

                            <p className={'s11'}>
                                {/*Données des infos du particulier*/}
                                <label>
                                    <Field type={'radio'} name={'estUnParticulierPayeur'} value={'oui'} />
                                    <span style={{ color: '#0088cb' }}>Particulier</span>
                                </label>
                                <span style={{ color: '#231F20' }}>
                                    {/*valeur Madame*/}
                                    <label>
                                        <Field type={'radio'} name={'civilitePayeur'} value={'Madame'} />
                                        <span>Madame</span>
                                    </label>
                                    {/*valeur Monsieur*/}
                                    <label>
                                        <Field type={'radio'} name={'civilitePayeur'} value={'Monsieur'} />
                                        <span>Monsieur</span>
                                    </label>
                                    {/*valeur nom*/}
                                    Nom : <Field type={'text'} name={'nomPayeur'} />
                                    {/*valeur prenom*/}
                                    Prénom : <Field type={'text'} name={'prenomPayeur'} />
                                </span>
                            </p>
                            <p className={'s11'}>
                                {/*donnée entreprise*/}
                                <label>
                                    <Field type={'radio'} name={'estUnParticulierPayeur'} value={'non'} />
                                    <span style={{ color: '#0088cb' }}>Entreprise, association, collectivité</span>
                                </label>
                                {/*nom et dossier*/}
                                <span style={{ color: '#231F20' }}>
                                    Nom : <Field type={'text'} name={'nomEntreprisePayeur'} />
                                    Dossier suivi par : <Field type={'text'} name={'dossierSuiviParPayeur'} />
                                </span>
                            </p>
                            {/*SIRET*/}
                            <p className={'s11'}>
                                N° SIRET : <Field type={'text'} name={'siretPayeur'} />
                            </p>
                            {/*adresse*/}
                            <p className={'s11'}>
                                Adresse (N°/additif/voie) :<Field type={'text'} name={'adressePayeur'} />
                            </p>
                            {/*code postal et commune*/}
                            <p className={'s11'}>
                                Code postal : <Field type={'text'} name={'codePostalPayeur'} />
                                Commune : <Field type={'text'} name={'communePayeur'} />
                            </p>
                            {/*telephone et email*/}
                            <p className={'s11'}>
                                Téléphone (Portable et/ou fixe) : <Field type={'text'} name={'telephonePayeur'} />
                                Email : <Field type={'text'} name={'emailPayeur'} />
                            </p>
                        </td>
                        <td width={'5%'}></td>
                    </tr>
                    {/*Bien à contrôler, lieu de contrôle, personne présente lors du contrôle*/}
                    <tr>
                        {/*logo*/}
                        <td width={'5%'} style={{ textAlign: 'right' }}>
                            <p
                                style={{
                                    marginTop: '20px',
                                    marginBottom: '10px',
                                    padding: '5px',
                                }}
                            >
                                <img src={logoTwo} style={{ height: '30px' }} alt={'Numéro 2'} />
                            </p>
                        </td>
                        <td style={{ width: '90%' }}>
                            {/*titre*/}
                            <p
                                style={{
                                    backgroundColor: '#4EC6E0',
                                    marginTop: '20px',
                                    marginBottom: '10px',
                                    padding: '5px',
                                }}
                            >
                                <span className={'h3'}>
                                    Bien à contrôler, lieu de contrôle, personne présente lors du contrôle
                                </span>
                            </p>
                        </td>
                        <td width={'5%'}></td>
                    </tr>
                    {/*Infos du bien à contrôler*/}
                    <tr>
                        <td width={'5%'} className={'tdImage'}></td>
                        {/* Type du bien */}
                        <td width={'90%'}>
                            <div className={'s8'} style={{ display: 'flex', alignItems: 'center', flexWrap: 'wrap' }}>
                                <ForwardIcon />
                                <span className={'s10'}>Type de bien à contrôler</span>
                            </div>
                            <p className={'s11'}>
                                {/*Maison individuelle*/}
                                <label>
                                    <Field type={'radio'} name={'typeLogement'} value={'Maison individuelle'} />
                                    <span>Maison individuelle</span>
                                </label>
                                {/*Appartement*/}
                                <label>
                                    <Field type={'radio'} name={'typeLogement'} value={'Appartement'} />
                                    <span>Appartement</span>
                                </label>
                                {/*Bâtiment*/}
                                (Préciser : Bâtiment <Field
                                    type={'text'}
                                    name={'batiment'}
                                    style={{ width: '30px' }}
                                />{' '}
                                {/*N*/}
                                N°
                                <Field type={'text'} name={'numEtage'} style={{ width: '30px' }} />
                                {/*Étage*/}
                                Étage
                                {/*Pallier*/}
                                <Field type={'text'} name={'pallier'} style={{ width: '30px' }} />
                                Pallier)
                            </p>
                            <p className={'s11'} style={{ marginTop: '5px' }}>
                                {/*Parties communes immeuble*/}
                                <label>
                                    <Field type={'checkbox'} name={'partiesCommunes'} value={'oui'} />
                                    <span>
                                        Parties communes immeuble{' '}
                                        <span className={'s12'}>
                                            (Pieds de colonne de chute d’eaux usées et de gouttières en partie
                                            extérieure, local poubelle, hall, ....)
                                        </span>
                                    </span>
                                </label>
                            </p>
                            <p className={'s11'} style={{ marginTop: '5px' }}>
                                {/*Commerce, bureau, activité autre qu’industrielle*/}
                                <label>
                                    <Field type={'checkbox'} name={'commerce'} value={'oui'} />
                                    <span>Commerce, bureau, activité autre qu’industrielle </span>
                                    (NAF obligatoire pour professionnel
                                    {/*obligatoire pour professionnel*/}
                                    <Field type={'text'} name={'codeNAFCommerce'} />)
                                </label>
                            </p>
                            <p className={'s11'} style={{ marginTop: '5px' }}>
                                {/*Installation industrielle*/}
                                <label>
                                    <Field type={'checkbox'} name={'industrielle'} value={'oui'} />
                                    <span>Installation industrielle </span>
                                    (NAF obligatoire pour professionnel
                                    {/*obligatoire pour professionnel*/}
                                    <Field type={'text'} name={'codeNAFIndustrielle'} />)
                                </label>
                            </p>
                        </td>
                        <td width={'5%'}></td>
                    </tr>
                    {/*Lieu du contrôle*/}
                    <tr>
                        <td width={'5%'} className={'tdImage'}></td>
                        <td width={'90%'} style={{ paddingTop: '10px' }}>
                            {/*Lieu de contrôle*/}
                            <div className={'s8'} style={{ display: 'flex', alignItems: 'center', flexWrap: 'wrap' }}>
                                <ForwardIcon />
                                <span className={'s10'}>Lieu de contrôle</span>
                            </div>
                            {/*Nombre de pièces avec points d’eau*/}
                            <p className={'s11-bold'}>
                                Nombre de pièces avec points d’eau (Obligatoire) :{' '}
                                <Field type={'text'} name={'nbPieceEau'} />
                            </p>
                            {/*Adresse*/}
                            <p className={'s11'}>
                                Adresse (N°/additif/voie) :
                                <Field type={'text'} name={'addressControle'} />
                            </p>
                            <p className={'s11'}>
                                {/*Code postal*/}
                                Code postal :
                                <Field type={'text'} name={'codePostalControle'} />
                                {/*Commune*/}
                                Commune :
                                <Field type={'text'} name={'communeControle'} />
                            </p>
                            <p className={'s11'}>
                                {/*Références cadastrales : Section*/}
                                Références cadastrales : Section
                                <Field type={'text'} name={'referencesCadastralesSection'} />
                                {/*Parcelle*/}
                                Parcelle(s) n°
                                <Field type={'text'} name={'referencesCadastralesParcelle'} />
                                {/*Lot*/}
                                Lot(s)
                                <Field type={'text'} name={'referencesCadastralesLot'} />
                            </p>
                        </td>
                        <td width={'5%'}></td>
                    </tr>
                    {/* Personne présente lors du contrôle */}
                    <tr>
                        <td width={'5%'} className={'tdImage'}></td>
                        <td width={'90%'} style={{ paddingTop: '10px' }}>
                            <div className={'s8'} style={{ display: 'flex', alignItems: 'center', flexWrap: 'wrap' }}>
                                {/*Personne présente lors du contrôle*/}
                                <ForwardIcon />
                                <span className={'s10'}>
                                    Personne présente lors du contrôle{' '}
                                    <span className={'s13'}> (Le rendez-vous sera pris avec cette personne)</span>
                                </span>
                            </div>
                            <p className={'s11'}>
                                {/*Demandeur*/}
                                <label>
                                    <Field type={'radio'} name={'personnePresente'} value={'Demandeur'} />
                                    <span>Demandeur</span>
                                </label>
                                {/*Proprétaire*/}
                                <label>
                                    <Field type={'radio'} name={'personnePresente'} value={'Proprétaire'} />
                                    <span>Proprétaire</span>
                                </label>
                                {/*Autre, préciser*/}
                                <label>
                                    <Field type={'radio'} name={'personnePresente'} value={'Autre'} />
                                    <span>Autre, préciser :</span>
                                    {/*other*/}
                                    <Field type={'text'} name={'personnePresenteAutre'} />
                                </label>
                            </p>
                            <p className={'s11'}>
                                {/*Madame*/}
                                <label>
                                    <Field type={'radio'} name={'civiliteControle'} value={'Madame'} />
                                    <span>Madame</span>
                                </label>
                                {/*Monsieur*/}
                                <label>
                                    <Field type={'radio'} name={'civiliteControle'} value={'Monsieur'} />
                                    <span>Monsieur</span>
                                </label>
                                {/*Nom*/}
                                Nom :
                                <Field type={'text'} name={'nomControle'} style={{ width: '150px' }} />
                                {/*Prénom*/}
                                Prénom :
                                <Field type={'text'} name={'prenomControle'} style={{ width: '150px' }} />
                                {/*Telephone*/}
                                Téléphone (Portable et/ou fixe) :
                                <Field type={'text'} name={'telephoneControle'} style={{ width: '150px' }} />
                            </p>
                        </td>
                        <td width={'5%'}></td>
                    </tr>
                    <tr>
                        <td width={'5%'} className={'tdImage'}></td>
                        <td width={'90%'}>
                            <div
                                style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    flexWrap: 'wrap',
                                    justifyContent: 'space-around',
                                    marginTop: '10px',
                                    width: '100%',
                                }}
                            >
                                {/* Informations sur le formulaire */}
                                <img
                                    id={'imgCoordinates'}
                                    src={infosSddea}
                                    style={{ height: '180px' }}
                                    alt={
                                        'Formulaire de demande de rendez-vous à renvoyer à l\'adresse mail "controle-ac@sddea.fr" ou par courrier à l\'adresse "Régie du SDDEA Cellule contrôle de raccordement à l\'assainissement collectif 4 rue Jean Monnet 10600 La Chapelle-Saint-Luc" Accueil téléphonique de la relation aux usagers du lundi au jeudi de 8h à 17h30 et le vendredi de 8h à 17h au numéro 03 25 83 27 10.'
                                    }
                                />
                                {/* Bloc de signature */}
                                <img
                                    id={'imgSignate'}
                                    src={blocSign}
                                    style={{ height: '220px' }}
                                    alt={
                                        "Le demandeur reconnaît avoir pris connaissance et accepter les conditions d'exécution de la prestation de contrôle au verso du présent document."
                                    }
                                />
                            </div>
                        </td>
                        <td width={'5%'}></td>
                    </tr>
                    {/*Montant du contrôle*/}
                    <tr>
                        <td width={'5%'} className={'tdImage'} style={{ textAlign: 'right' }}>
                            <p
                                style={{
                                    marginBottom: '5px',
                                    padding: '5px',
                                }}
                            >
                                {/*image*/}
                                <img src={logoThree} style={{ height: '30px' }} alt={'Numéro 3'} />
                            </p>
                        </td>
                        <td style={{ width: '90%' }}>
                            {/*titre*/}
                            <p
                                style={{
                                    backgroundColor: '#4EC6E0',
                                    marginBottom: '5px',
                                    padding: '5px',
                                }}
                            >
                                <span className={'h3'}>Montant du contrôle</span>
                            </p>
                        </td>
                        <td width={'5%'}></td>
                    </tr>
                    <tr>
                        {/*Texte texte et encore texte*/}
                        <td width={'5%'}></td>
                        <td style={{ width: '90%' }}>
                            {/*titre*/}
                            <p className={'s11'} style={{ textAlign: 'justify' }}>
                                Le montant du contrôle est de 184,59 € HT soit{' '}
                                <span className={'s11-bold'}>
                                    203,05 € TTC par logement pour un contrôle de nouveau raccordement et / ou
                                    construction neuve.
                                </span>
                            </p>
                            {/*texte 1 */}
                            <p className={'s11'} style={{ textAlign: 'justify' }}>
                                Détail du calcul du montant de la redevance de contrôle : coût horaire de 65,18 € HT
                                majoré de 18% (pour facturation à des tiers) soit 76,91 € HT/h{' '}
                                <span className={'s14'}>
                                    (Délibérations n° CA20221215_18 et n° CA20221215_19 du conseil administration de la
                                    régie du SDDEA en date du 15 décembre 2022)
                                </span>
                            </p>
                            {/*texte 2*/}
                            <p className={'s11'} style={{ textAlign: 'justify' }}>
                                Le temps moyen passé par contrôle (Prise de rendez-vous, temps de trajet, contrôle sur
                                le terrain, rédaction du compte-rendu) étant de 2,4 h, le montant du contrôle s’établit
                                ainsi 2,4 h x 76,91 € HT/h = 184,59 € HT soit 203,051 € TTC (TVA 10%) (Tarif
                                actualisable chaque année et applicable selon l’année de réalisation du contrôle).
                            </p>
                        </td>
                        <td width={'5%'}></td>
                    </tr>
                    {/*Documents à fournir lors du rendez-vous*/}
                    <tr>
                        <td width={'5%'} className={'tdImage'} style={{ textAlign: 'right' }}>
                            <p
                                style={{
                                    marginBottom: '5px',
                                    padding: '5px',
                                }}
                            >
                                {/*logo*/}
                                <img src={logoFour} style={{ height: '30px' }} alt={'Numéro 4'} />
                            </p>
                        </td>
                        <td style={{ width: '90%' }}>
                            {/*titre*/}
                            <p
                                style={{
                                    backgroundColor: '#4EC6E0',
                                    marginBottom: '5px',
                                    padding: '5px',
                                }}
                            >
                                <span className={'h3'}>Documents à fournir lors du rendez-vous </span>
                                <span className={'s6'}>(si possible)</span>
                            </p>
                        </td>
                        <td width={'5%'}></td>
                    </tr>
                    <tr>
                        <td width={'5%'} className={'tdImage'}></td>
                        <td style={{ width: '90%' }}>
                            {/*texte*/}
                            <p className={'s11'} style={{ textAlign: 'justify' }}>
                                Plan cadastral, plan de situation, tout document relatif à l’assainissement collectif en
                                place (Plan du permis de construire, plan de récolement, certificat de vidange,
                                photographies...).
                            </p>
                        </td>
                        <td width={'5%'}></td>
                    </tr>
                    {/*Destinataire et conditions d’envoi du rapport de contrôle*/}
                    <tr>
                        <td width={'5%'} className={'tdImage'} style={{ textAlign: 'right' }}>
                            <p
                                style={{
                                    marginBottom: '5px',
                                    padding: '5px',
                                }}
                            >
                                {/*logo*/}
                                <img src={logoFive} style={{ height: '30px' }} alt={'Numéro 5'} />
                            </p>
                        </td>
                        <td style={{ width: '90%' }}>
                            {/*titre*/}
                            <p
                                style={{
                                    backgroundColor: '#4EC6E0',
                                    marginBottom: '5px',
                                    padding: '5px',
                                }}
                            >
                                <span className={'h3'}>Destinataire et conditions d’envoi du rapport de contrôle</span>
                            </p>
                        </td>
                        <td width={'5%'}></td>
                    </tr>
                    <tr>
                        <td width={'5%'} className={'tdImage'}></td>
                        <td style={{ width: '90%' }}>
                            {/*Rapport*/}
                            <p className={'s11'} style={{ textAlign: 'justify' }}>
                                Rapport de contrôle à envoyer : {/*Au propriétaire*/}
                                <label>
                                    <Field type={'radio'} name={'rapport'} value={'Au propriétaire'} />
                                    <span>Au propriétaire</span>
                                </label>
                                {/*Au demandeur*/}
                                <label>
                                    <Field type={'radio'} name={'rapport'} value={'Au demandeur'} />
                                    <span>Au demandeur</span>
                                </label>
                                {/*Au payeur*/}
                                <label>
                                    <Field type={'radio'} name={'rapport'} value={'Au payeur'} />
                                    <span>Au payeur</span>
                                </label>
                            </p>
                            {/*Transmission de rapport*/}
                            <p className={'s11'} style={{ textAlign: 'justify', marginTop: '5px' }}>
                                Transmission du rapport : {/*Par courrier*/}
                                <label>
                                    <Field type={'radio'} name={'rapportTransmission'} value={'Par courrier'} />
                                    <span>Par courrier</span>
                                </label>
                                {/*Par voie électronique*/}
                                <label>
                                    <Field
                                        type={'radio'}
                                        name={'rapportTransmission'}
                                        value={'Par voie électronique'}
                                    />
                                    <span>Par voie électronique</span>
                                    (Adresse mail d’envoi : <Field type={'text'} name={'rapportEmail'} />)
                                </label>
                            </p>
                        </td>
                        <td width={'5%'}></td>
                    </tr>
                    {/*Conditions d’exécution de la prestation*/}
                    <tr>
                        <td width={'5%'} className={'tdImage'} style={{ textAlign: 'right' }}>
                            <p
                                style={{
                                    marginBottom: '5px',
                                    padding: '5px',
                                }}
                            >
                                {/*logo*/}
                                <img src={logoFive} style={{ height: '30px' }} alt={'Numéro 5'} />
                            </p>
                        </td>
                        <td style={{ width: '90%' }}>
                            {/*titre*/}
                            <p
                                style={{
                                    backgroundColor: '#4EC6E0',
                                    marginBottom: '5px',
                                    padding: '5px',
                                }}
                            >
                                <span className={'h3'}>Conditions d’exécution de la prestation</span>
                            </p>
                        </td>
                        <td width={'5%'}></td>
                    </tr>
                    <tr>
                        <td width={'5%'} className={'tdImage'}></td>
                        <td style={{ width: '90%' }}>
                            {/*Article 1*/}
                            <h4>Article 1 - Obligation de contrôle de raccordement</h4>
                            {/*Transmission de rapport*/}
                            <p className={'s12'} style={{ textAlign: 'justify' }}>
                                La Régie du SDDEA réalise, à la demande des usagers, des contrôles de raccordement à
                                l’assainissement collectif. Ils sont obligatoires lors de la création et en cas de
                                modifications ultérieures des installations privatives d’eaux usées. Ces derniers ne
                                sont pas obligatoires dans le cadre des ventes. Toutefois, ils permettent d’apporter des
                                garanties au vendeur vis-à-vis de l’acheteur sur la conformité du raccordement des
                                installations privatives d’eaux usées vers le réseau public de collecte des eaux usées.
                            </p>
                        </td>
                        <td width={'5%'}></td>
                    </tr>
                    <tr>
                        <td width={'5%'} className={'tdImage'}></td>
                        <td style={{ width: '90%', paddingTop: '10px' }}>
                            {/*Article 2*/}
                            <h4>Article 2 - Définition et déroulement de la prestation</h4>
                            {/*Transmission de rapport*/}
                            <p className={'s12'} style={{ textAlign: 'justify' }}>
                                Le contrôle s’effectue de manière visuelle au moyen, le cas échéant, de test
                                d’écoulement d’eau et d’utilisation de colorant, afin de vérifier si possible le
                                raccordement des eaux usées produites par l’immeuble sur les points d’eau signalés, le
                                respect des eaux admises dans le réseau d’eaux usées et le respect de prescriptions
                                techniques relatives aux installations intérieures d’eaux usées (Prétraitements
                                éventuels, mise hors service des anciens ouvrages d’assainissement non collectif,
                                dispositifs contre les reflux d’eau,…). Ce contrôle ne préjuge pas de la bonne
                                réalisation des installations privatives conformément aux règles de l’art, à la
                                réglementation et aux normes applicables (notamment l’existence et le fonctionnement des
                                ventilations ou des siphons), ni de leur état de fonctionnement et d’entretien.
                            </p>
                            {/*texte*/}
                            <p className={'s12'} style={{ textAlign: 'justify' }}>
                                Si une contre-visite s’avère nécessaire, elle ne porte que sur la levée des anomalies
                                détectées au cours de la visite initiale. Si des modifications ont été apportées à
                                d’autres éléments ou que des points n’avaient pas été signalés, le propriétaire devra
                                compléter un nouveau formulaire pour demander une visite complète qui sera facturée.
                            </p>
                            {/*texte*/}
                            <p className={'s12'} style={{ textAlign: 'justify' }}>
                                L’arrivée des agents sur le lieu et le jour du contrôle s’effectue sur une période d’une
                                heure précisée lors de la prise de rendez-vous. Par exemple, sur la période 10-11 h, les
                                agents peuvent arriver à 10h15. Les agents ne sont pas habilités à travailler en
                                hauteur, en particulier les descentes d’eaux pluviales devront être équipées de points
                                d’accès à hauteur d’homme.
                            </p>
                            {/*texte*/}
                            <p className={'s12'} style={{ textAlign: 'justify' }}>
                                À réception de ce formulaire dûment complété et signé, la régie du SDDEA prend contact
                                par téléphone pour la prise de rendez-vous. Le rapport de contrôle est transmis dans un
                                délai de 6 semaines à compter de la demande de contrôle, à condition que le rendez-vous
                                de contrôle soit fixé dans un délai de 3 semaines à compter de la demande. Le rapport
                                est envoyé (en un seul exemplaire en cas d’envoi papier) à la personne indiquée dans le
                                formulaire.
                            </p>
                        </td>
                        <td width={'5%'}></td>
                    </tr>
                    <tr>
                        <td width={'5%'} className={'tdImage'}></td>
                        <td style={{ width: '90%', paddingTop: '10px' }}>
                            {/*Article 3*/}
                            <h4>Article 3 - Durée de validité du contrôle</h4>
                            {/*Transmission de rapport*/}
                            <p className={'s12'} style={{ textAlign: 'justify' }}>
                                Les attestations de raccordement sont établies à la date du contrôle. Leur délai de
                                validité est de dix ans pour les constructions neuves et les parties communes privatives
                                des immeubles collectifs d’habitations ou des lotissements. Elle est de cinq ans pour
                                les contrôles de vente (Hors parties communes). Si le propriétaire vendeur est en
                                possession d’une attestation encore valide, il peut certifier auprès du futur acquéreur
                                que tous les points d’eau existants figurent sur le constat initial, n’avoir effectué
                                aucuns travaux depuis la date du contrôle et que le document est le dernier transmis.
                            </p>
                        </td>
                        <td width={'5%'}></td>
                    </tr>
                    <tr>
                        <td width={'5%'} className={'tdImage'}></td>
                        <td style={{ width: '90%', paddingTop: '10px' }}>
                            {/*Article 4*/}
                            <h4>Article 4 - Engagements du demandeur payeur</h4>
                            {/*Transmission de rapport*/}
                            <p className={'s12'} style={{ textAlign: 'justify' }}>
                                Le demandeur, ou son représentant dument habilité, s’engage à être présent le jour du
                                contrôle, à signaler aux contrôleurs les différents ouvrages du réseau d’assainissement
                                (Pompes, puisard, fosses septiques. ) et les différents points d’eau, y compris ceux
                                existant dans les locaux annexes (Greniers, caves, garages, dépendances, cuisine
                                extérieure…). Il s’engage à fournir l’eau nécessaire à la bonne réalisation du contrôle.
                                Le rapport de visite ne pourra porter que sur les ouvrages et points d’eau signalés, en
                                service et rendus accessibles, au vu des renseignements fournis par le demandeur et sous
                                sa responsabilité.
                            </p>
                            {/*texte*/}
                            <p className={'s12'} style={{ textAlign: 'justify' }}>
                                Le demandeur payeur s’engage à régler le coût de la prestation de contrôle, selon les
                                tarifs indiqués ci-dessus. Le paiement du contrôle se fait à la réception d’un titre de
                                recettes à la trésorerie départementale, lequel parviendra sous 3 mois environ à compter
                                de la date de contrôle.
                            </p>
                        </td>
                        <td width={'5%'}></td>
                    </tr>
                    <tr>
                        <td width={'5%'} className={'tdImage'}></td>
                        <td style={{ width: '90%', paddingTop: '10px' }}>
                            {/*Article 5*/}
                            <h4>Article 5 - Protection des données</h4>
                            {/*Transmission de rapport*/}
                            <p className={'s12'} style={{ textAlign: 'justify' }}>
                                Les informations à caractère personnel recueillies sur ce formulaire font l’objet d’un
                                traitement informatisé par la Régie du SDDEA, afin d’exécuter et de suivre les contrôles
                                de raccordement des installations privatives au réseau public d’assainissement
                                collectif, en application de l’article L. 1331-4 du code de la Santé Publique, de
                                l’article L.2224-8 du Code général des collectivités territoriales.
                            </p>
                            {/*texte*/}
                            <p className={'s12'} style={{ textAlign: 'justify' }}>
                                Les destinataires de ces données sont les agents techniques et administratifs de la
                                Régie du SDDEA, dans la limite de leurs attributions respectives, et le cas échéant, des
                                organismes habilités (DGFIP, Agence de l’Eau, Bureau d’études), mais en aucun cas pour
                                prospection commerciale.
                            </p>
                            {/*texte*/}
                            <p className={'s12'} style={{ textAlign: 'justify' }}>
                                Ces données seront conservées jusqu’à l’établissement d’un nouveau constat de bon
                                raccordement au propriétaire.
                            </p>
                            {/*texte*/}
                            <p className={'s12'} style={{ textAlign: 'justify' }}>
                                Conformément à la Loi Informatique et Libertés et au Règlement européen sur la
                                protection des données, vous bénéficiez des droits d’accès, de rectification et
                                d’effacement de vos données ou encore de limitation du traitement, droits que vous
                                pouvez exercer en contactant le Délégué à la Protection des Données par courriel à
                                l’adresse{' '}
                                <a href="mailto:dpo@sddea.fr" className={'s19'} target="_blank" rel="noreferrer">
                                    dpo@sddea.fr.
                                </a>
                            </p>
                            {/*texte*/}
                            <p className={'s12'} style={{ textAlign: 'justify' }}>
                                Pour toute information complémentaire ou réclamation, vous pouvez contacter la
                                Commission Nationale de l’Informatique et des Libertés ou consulter son site :{' '}
                                <a href="https://www.cnil.fr/" className={'s19'} target="_blank" rel="noreferrer">
                                    www.cnil.fr.
                                </a>
                            </p>
                        </td>
                        <td width={'5%'}></td>
                    </tr>
                    <tr>
                        {/* Informations légales */}
                        <td width={'5%'}></td>
                        <td style={{ width: '90%', paddingTop: '10px' }}>
                            {/*adresse*/}
                            <p className={'s20'} style={{ textAlign: 'justify' }}>
                                Régie du SDDEA - CELLULE CONTRÔLE DE RACCORDEMENT À L’ASSAINISSEMENT NON COLLECTIF
                            </p>
                            {/*adresse*/}
                            <p className={'s20'}>
                                4 rue Jean Monnet – 10600 La Chapelle-Saint-Luc - Tél. 03 25 83 27 10 – Email :{' '}
                                <a
                                    href="mailto:controle-ac@sddea.fr"
                                    className={'s21'}
                                    target="_blank"
                                    rel="noreferrer"
                                >
                                    controle-ac@sddea.fr
                                </a>
                            </p>
                            {/*texte*/}
                            <p className={'s20'}>
                                Les informations recueillies sur ce formulaire font l’objet d’un traitement informatisé
                                par la Régie du SDDEA. Les destinataires de ces informations sont les agents techniques
                                et administratifs de la Régie du SDDEA, dans la limite de leurs attributions respectives
                                et, le cas échéant, les services de la DGFIP. Sauf mention contraire, l’ensemble des
                                champs du formulaire sont obligatoires pour exécuter votre demande. Vous pouvez accéder
                                aux données vous concernant, les rectifier, demander leur effacement ou exercer votre
                                droit à la limitation du traitement de vos données. Pour plus d’informations sur vos
                                droits, consultez le site{' '}
                                <a href="https://www.cnil.fr/" className={'s22'} target="_blank" rel="noreferrer">
                                    www.cnil.fr.
                                </a>{' '}
                                Pour exercer vos droits « informatique et libertés », vous pouvez contacter le Délégué à
                                la Protection des Données par courriel à l’adresse
                                <a href="mailto:dpo@sddea.fr" className={'s21'} target="_blank" rel="noreferrer">
                                    {' '}
                                    dpo@sddea.fr
                                </a>
                            </p>
                        </td>
                        <td width={'5%'}></td>
                    </tr>
                </tbody>
            </table>
        </div>
    );
}
